import React from 'react';
import '@ui5/webcomponents-fiori/dist/illustrations/tnt/UnsuccessfulAuth';
import {
  Button,
  ButtonDesign,
  IllustratedMessage,
  IllustrationMessageType
} from '@ui5/webcomponents-react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './AuthenticationErrorPage.jss';

export const AuthenticationErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const onReturnToMainPage = () => {
    location.assign('/queries');
  };

  return (
    <IllustratedMessage
      name={IllustrationMessageType.TntUnsuccessfulAuth}
      data-help-id="no-permission-illustration"
      titleText={t('no-permission-title')}
      subtitleText={t('no-permission-subtitle')}
      className={classes.illustratedMessage}
    >
      <Button design={ButtonDesign.Emphasized} onClick={onReturnToMainPage}>
        {t('return-home-screen')}
      </Button>
    </IllustratedMessage>
  );
};
